export const words = {
  place: "Placering",
  yes: 'Ja',
  no: "Nej, det er det ikke",
  new: "Ny",
  agb: 'AGB',
  agb_full: "Generelle vilkår og betingelser",
  datenschutzerklaerung: "Politik om beskyttelse af personlige oplysninger",
  status: 'Status',
  company_name: "Virksomhedens navn",
  next_button: "Yderligere",
  device_name: "Enhedens navn",
  to_connect: "Forbind",
  pin: "PIN-KODE",
  time: "Tid",
  first_name: "Fornavn",
  last_name: "Efternavn",
  code: "Kode",
  help: "Hjælp",
  total_time: "Samlet tid",
  latitude: "Breddegrad",
  longitude: "Længdegrad",
  accuracy: "Nøjagtighed",
  timestamp: "Tidsstempel",
  device_id: "Enheds-id",
  active: 'aktiv',
  o_clock: "Ur",
  loading: "Butik",
  annotation: "Bemærk",
  since: "siden",
  camera: 'Kamera',
  map: "Kort",
  gallery: "Galleri",
  work: "Arbejde",
  employees: "Medarbejdere",
  login: "Registrering",
  login_action: "Log ind",
  calendar_week_abbreviation: 'KW',
  calendar: 'Kalender',
  to_call: "Ring til",
  email: "E-mail",
  attachment: "Appendiks",
  operational_planning: "Operationel plan",
  to_scan: "Scan",
  download: "Download",
  export: "Eksport",
  to_document: "Dokument",
  checklist: "Tjekliste",
  checklists: "Tjeklister",
  password: "Adgangskode",
  confirmation: "Konfirmation",
  confirm: "Bekræft",
  confirmation_email: "Bekræftelse af e-mail",
  unknown: "Ukendt",
  unknown_place: "Ukendt placering",
  unknown_plan: "Unavngivet vagtplan",
  project_no: "Projekt nr.",
  project_file: "Projektfil",
  contact_person: "Kontakt",
  overtime: "Overarbejde",
  timesheet: "Tidsplan",
  minustime: "Minus timer",
  back: "Tilbage",
  undo: "Fortryd",
  clockout: "Udstempling",
  clocked_out: "stemplet",
  clockin: "Stempel i",
  clocked_in: "stemplet",
  dismiss: "Annuller",
  discard: "Afvise",
  finish: "Klar",
  or: "eller",
  copy: "Eksemplar",
  qr_code: "QR-kode",
  documentation: "Tidsregistrering og dokumentation",
  attendance: "Tablet-terminal",
  tiercontent: "Pakkeomfang",
  start_now: "Kom i gang nu",
  skip: "Spring over",
  logout_during_core_time: "Stemplet ud i løbet af kernetiden",
  absent_during_core_time: "Fraværende i kernetiden",
  distance: "Afstand",
  km_reading: 'Kilometerstand',
  the_start: 'Start',
  the_end: "Slut",
  license_plate: "Nummerplade",
  details: "detaljer",
  hide: "gemme sig",
  cost: "Omkostninger",
  file: "Fil",
  address_book: "Adressebog",
  template_plural: "Skabeloner",
  signature: "Signatur",
  main_project: "Hovedprojekt",
  main_projects: "Vigtigste projekter",
  sub_projects: "Delprojekter",
  scan_to_login_header: "Registrering af QR-kode",
  description: "Beskrivelse",
  project_location: "Projektets placering",
  phone_number: "Telefon nummer",
  project_info: "Oplysninger om projektet",
  number_short: "Nej, det er det ikke.",
  sketch: "Skitse",
  video: 'Video',
  delete: "Slet",
  send: "Send",
  sending: "Sende...",
  save: "Gem",
  granted: "godkendt",
  pending: "anmodet",
  denied: "Afvist",
  customer: 'Kunde',
  mobile_number: 'Telefonnummer',
  ok: 'Ok',
  day: "Dag",
  tomorrow: "Morgen",
  days: "Dage | Dag | Dage",
  holidays: "Ferie",
  vacation_days: "Ferie",
  vacation_hours: "Åbningstider for ferie",
  request: "Anmodning",
  accept: "Accepter",
  withdraw: "Trække",
  hour_account: "Konto pr. time",
  period: "Periode",
  to: "til",
  date: "Udnævnelse",
  number: "Nummer",
  message: "Besked",
  change: "ændre",
  changed: "Ændret",
  changed_fields: "Skiftede felt",
  type: "Kunst",
  hour: "Timer",
  hours: "Timer",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Timer",
  end: "end",
  end_date: "Deadline",
  start_date: "Startdato",
  absence: "Fravær",
  month: "måned",
  week: "Uge",
  transcript: "Udskrift",
  time_left: "resterende",
  transcript_tasks: "Opgaver",
  add_task: "Ny",
  /** Differentiation in some languages (e.g. English) */
  from: "fra",
  of: "fra",
  of_hours: "fra {hours} timer",
  of_hours_abbreviation: "{hours} fra timer.",
  /**************/

  used: "brugt",
  update: "Opdatering",
  today: "i dag",
  correction: "Rettelse",
  work_time: "Arbejdstid",
  break: 'Pause',
  loading_time: "Indlæsningstid",
  driving_time: "Rejsetid",
  business_trip: "Tjenesteperiode",
  project: 'Projekt',
  special_one: "Special1",
  special_two: "Special2",
  clock: "Ur",
  search: "Søg på",
  operation: "Aktivitet",
  day_protocol: "Daglig protokol",
  continue: "mere",
  total_duration: "Samlet tid",
  duration: "Varighed",
  hello: "Hej",
  close: "luk",
  comment: 'Kommentar',
  small: "lille",
  medium: "medium",
  large: "stor",
  sharpie: "Pin",
  line: "Linje",
  arrow: "Pile",
  rectangle: "Rektangel",
  ellipse: 'Ellipse',
  text: "Tekst",
  language_settings: "Sprogindstillinger",
  clock_reminder: "Frimærkepåmindelse",
  individually: "Individuel",
  from_o_clock: "fra",
  to_o_clock: "til",
  eraser: "Viskelæder",
  edit: "Rediger",
  legal_notes: "Juridisk",
  notes: "Noter",
  note: "Bemærk",
  imprint: "Tryk",
  open_source_licenses: "Vilkår for open source-licenser",
  author: "Forfatter",
  license_type: "Type af licens",
  version: 'Version',
  substitute: "Repræsentation",
  not_rated: "Ikke bedømt",
  weekly_working_hours: "Ugentlig arbejdstid",
  show_less: "Vis mindre",
  office_center: "Kontorcenter",
  admin_view: "NFC-administration",
  register: "Registrer",
  shifts: {
    shift_attachments: "Vedhæftninger (lag)",
    shift_plan_attachments: "Vedhæftede (skifteplan)",
    shift_plan: "Vagtplan",
    shift: "Lag"
  },
  absences: {
    sick: "Sygdom (fortsat lønudbetaling)",
    vacation: "Ferie",
    workshop: "Seminar/kursus",
    special_vacation: "Særlig orlov",
    school: "Skole",
    working_time_account: "Arbejdstidskonto",
    holiday: "Ferie",
    other: "Andre",
    driving_time: "Rejsetid",
    parental_leave: "Forældreorlov",
    excused_absent: "Fraværende undskyldt (betalt)",
    not_excused_absent: "Fravær uden undskyldning",
    sick_industrial_accident: "Sygdom Arbejdsulykke (LFZ)",
    short_time_work: "Korttidsarbejde (Kug)",
    maternity_pay: "Beskyttelsesydelse ved barsel/ansættelsesforbud",
    sick_child: "Pasning af et sygt barn med sygeløn (dagpenge)",
    sick_child_no_payment: "Pasning af et sygt barn uden sygedagpenge",
    vacation_no_payment: "Ulønnet ferie",
    sick_before_short_time_work: "Sygedagpenge/sygdom før Kug",
    weather_related_failure: "Svigt på grund af vejrforhold",
    sick_short_time_work: "Sygdom under Kug",
    sick_no_payment: "Sygdom (uden fortsat lønudbetaling)",
    company_vacation: "Virksomhedens ferie",
    meals_14_euro: "Lille forplejningstillæg",
    meals_28_euro: "Stort tilskud til forplejning"
  },
  image_editor: {
    font_size: "Skriftstørrelse",
    stroke_width: "Linjebredde",
    stroke_color: "Linjefarve",
    text_color: "Farve på skrifttype",
    rotate_left: "Drej til venstre",
    rotate_right: "Drej til højre",
    flip_horizontal: "Spejl vandret",
    flip_vertical: "Spejl lodret"
  },
  travel_log: {
    method_of_transportation: "Transportmidler",
    company_car: "Firmabil",
    private_car: "Privat bil",
    rental_car: "Lejebil",
    taxi: "Taxa",
    public_transportation: "Offentlig transport",
    airplane: "Flyvemaskine",
    train: "Jernbane (offentlig transport over lange afstande)",
    other: "Andet",
    km_reading_start: "Start af kilometertal",
    km_reading_end: "Kilometerstand slut",
    net_expenses: "Rejseudgifter (netto)",
    tax: "Merværdiafgift"
  },
  read_in: "Læs ind",
  currency: "Valuta",
  reason: "Årsag",
  label: "Etiket",
  monday: "Mandag",
  tuesday: "Tirsdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lørdag",
  sunday: "Søndag",
  break_alarm: "Bryd vækkeuret",
  clockin_reminder: "Påmindelse om indstempling",
  clockout_reminder: "Påmindelse om afmeld"
};